module.exports = __webpack_public_path__ + "static/sport/bgi-h5.01312d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport/bgi-h5.jpg
// module id = +7KZ
// module chunks = 0